import { Skeleton } from 'primereact/skeleton';
import './SkeletonWrapper.scss';

export const SkeletonWrapper = (props: { children: any, isLoading: boolean, width?: string, height?: string }) => {
    return props.isLoading ? <Skeleton className='inline-block' height={props.height} width={props.width} /> : <>{props.children}</>
}